import {
  updateDepositAccountRecommendedPackagePaymentStatus,
  updateDepositAccountPaymentStatus,
} from '../../../actions/depositAccount';

export enum EPaymentStatusCheckType {
  Balance = 'Balance',
  Package = 'Package',
}

export const CHANGE_PAYMENT_STATUS_ACTION = {
  [EPaymentStatusCheckType.Package]: updateDepositAccountRecommendedPackagePaymentStatus,
  [EPaymentStatusCheckType.Balance]: updateDepositAccountPaymentStatus,
};
